export default [
    {
        path: '/app/points/setting.html',
        component: (resolve) => require(['@/view/app/points/setting/index.vue'],resolve),
    },
]
